/*
  used in sections/main-product.liquid
  inserted <script src="{{ 'ccustomReadMoreJs.js' | asset_url }}" defer="defer"></script>

  Lyhentää tuotekuvauksen ja lisää "Näytä lisää" -painikkeen.
  Ilman JS:ää kuvaus näkyy kokonaan (collapse-tila lisätään vasta JS:llä).
*/

if (!customElements.get('ccustom-read-more')) {
  customElements.define(
    'ccustom-read-more',
    class CcustomReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.ccustom-read-more__content');
        this.toggle = this.querySelector('.ccustom-read-more__toggle');
        if (!this.content || !this.toggle) return;

        this.label = this.toggle.querySelector('.ccustom-read-more__toggle-text');
        this.onToggle = this.onToggle.bind(this);
        this.toggle.addEventListener('click', this.onToggle);

        this.update();

        // Kuvien, fonttien ja ikkunan koon muutokset vaikuttavat kuvauksen korkeuteen
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.content);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
      }

      get expanded() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      get collapsedHeight() {
        const value = parseInt(getComputedStyle(this).getPropertyValue('--ccustom-read-more-height'), 10);
        return Number.isNaN(value) ? 200 : value;
      }

      /* Näytetään painike vain jos kuvaus oikeasti jatkuu rajan yli */
      update() {
        if (this.expanded) return;
        const overflows = this.content.scrollHeight > this.collapsedHeight + 20;
        this.classList.toggle('ccustom-read-more--collapsed', overflows);
        this.toggle.hidden = !overflows;
      }

      onToggle() {
        const expanded = !this.expanded;

        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.classList.toggle('ccustom-read-more--collapsed', !expanded);

        if (this.label) {
          this.label.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
        }

        // Suljettaessa palautetaan kuvauksen alku näkyviin
        if (!expanded && this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
}
